"use client"
import { Badge, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"

const ProductTableItem = ({ product, handleShow, handleDelete }) => {
  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { color: "success", text: "Active" },
      inactive: { color: "secondary", text: "Inactive" },
      suspended: { color: "warning", text: "Suspended" },
      out_of_stock: { color: "danger", text: "Out of Stock" },
      pending: { color: "info", text: "Pending" },
    }

    const config = statusConfig[status] || { color: "secondary", text: status }
    return <Badge color={config.color}>{config.text}</Badge>
  }

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(price)
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  return (
    <tr>
      <td className="id">
        <span className="fw-medium">{product.id}</span>
      </td>
      <td className="product_title">
        <div className="d-flex align-items-center">
          {product.image_url && (
            <img
              src={product.image_url || "/placeholder.svg"}
              alt={product.title}
              className="avatar-xs rounded me-2"
              style={{ width: "32px", height: "32px", objectFit: "cover" }}
            />
          )}
          <div>
            <h6 className="mb-0">{product.title}</h6>
            {product.sku && <small className="text-muted">SKU: {product.sku}</small>}
          </div>
        </div>
      </td>
      <td className="category">
        <span className="text-muted">{product.category?.name || "No Category"}</span>
      </td>
      <td className="owner">
        <div>
          <h6 className="mb-0">{product.user?.name}</h6>
          <small className="text-muted">{product.user?.email}</small>
        </div>
      </td>
      <td className="price">
        <span className="fw-medium">{formatPrice(product.price)}</span>
      </td>
      <td className="status">{getStatusBadge(product.status)}</td>
      <td className="stock">
        <span className={`fw-medium ${product.stock_quantity <= 5 ? "text-danger" : "text-success"}`}>
          {product.stock_quantity || 0}
        </span>
      </td>
      <td className="date">
        <span className="text-muted">{formatDate(product.created_at)}</span>
      </td>
      <td>
        <div className="d-flex gap-2">
          <Button color="info" size="sm" onClick={() => handleShow(product)}>
            <i className="ri-eye-line align-bottom"></i>
          </Button>

          <UncontrolledDropdown>
            <DropdownToggle color="secondary" size="sm" caret>
              <i className="ri-more-2-fill"></i>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => handleShow(product)}>
                <i className="ri-eye-line align-bottom me-2 text-muted"></i>
                View Details
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={() => handleDelete(product.id)} className="text-danger">
                <i className="ri-delete-bin-line align-bottom me-2"></i>
                Delete
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </td>
    </tr>
  )
}

export default ProductTableItem
